import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as IssuesV2Store from '../../../../redux/issuesV2';
import IssueDetailsDependencySection from '../DependencySection';

/**
 * LicensingIssueDetailsDependency displays the dependency info
 * for the package where the licensing issue was found.
 */
const LicensingIssueDetailsDependency: VoidFunctionComponent = () => {
  const licenseCount = useSelector(IssuesV2Store.selectors.getIssueLicenseCount);
  const isPackageCorrected = useSelector(IssuesV2Store.selectors.getIsPackageCorrected);
  //  Check for errors with fetching the licenses. This can happen for any number of reasons,
  //  one being that this is a private project/package and the user does not have access to it.
  const { isLoading, errors } = useSelector(IssuesV2Store.selectors.getAsyncStatusIssueLicenses);
  const hasErrors = errors?.length;

  return (
    <IssueDetailsDependencySection
      isPackageCorrected={isPackageCorrected}
      additionalRows={
        //  Don't display the license count if we're still loading or if there are errors.
        isLoading || hasErrors ? [] : [
          {
            label: 'Detected licenses',
            content: <span className="font-family-monospace">{licenseCount}</span>,
          },
        ]
      }
    />
  );
};

export default LicensingIssueDetailsDependency;
